import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const deliveryFeeEndpoint = ENDPOINTS.DELIVERY_FEE;

// Category API
export const deliveryFeeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["deliveryFees"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDeliveryFees: builder.query({
        query: (payload) => `${deliveryFeeEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "deliveryFees" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addDeliveryFee: builder.mutation({
        query: (requestData) => ({
          url: `${deliveryFeeEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "deliveryFees" }],
      }),
      updateDeliveryFee: builder.mutation({
        query: ({id, requestData}) => ({
          url: `${deliveryFeeEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "deliveryFees" }],
      }),
      deleteDeliveryFee: builder.mutation({
        query: (id) => ({
          url: `${deliveryFeeEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "deliveryFees" }],
      }),
    }),
  });

// Export hooks for usage in components

export const { useGetDeliveryFeesQuery, useAddDeliveryFeeMutation, useDeleteDeliveryFeeMutation, useUpdateDeliveryFeeMutation } = deliveryFeeApi;
